import React from "react";

const DesktopSetingsIcon = ({ show }) => {
  return (
    <>
      <div onClick={show} className="icon desktopik">
        <span>Desktop Settings</span>
      </div>
    </>
  );
};

export default DesktopSetingsIcon;
